export default __webpack_public_path__ + "static/abhaziya-celo-pskhu-cerkov-useknoveniya-glavy-ioanna-predtechi_5-849af95be68117af79e23dda2514056d.jpg";